import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { Pyramide } from '@teetsh/app/src/types/pyramide';
import { PYRAMIDE_KEY } from './usePyramide';

interface Props {
  pyramideId: string;
}

export default function useUpdatePyramide(props: Props) {
  const { pyramideId } = props;
  const queryClient = useQueryClient();
  const { schoolyear, school } = useSchoolSchoolyear();

  const { mutateAsync } = useMutation({
    mutationFn: (pyramide: Pyramide) =>
      request(
        `/schoolyear/${schoolyear.id}/school/${school.id}/pyramides/${pyramideId}`,
        { method: 'PATCH', body: pyramide },
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [schoolyear.id, school.id, PYRAMIDE_KEY],
      });
    },
  });
  return mutateAsync;
}
